import {
    FETCH_EXPERIENCES
} from '../actions/experience';


export const initialState = {
    isFetching: true,
    data: null
};

export const experiences = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_EXPERIENCES}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_EXPERIENCES}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/experience.js